// Aggregated symptom pages. Add a new entry to the matching specialty file,
// it will appear here automatically.
import { UROLOGY_PAGES } from './urology';
import { ORTHOPEDICS_PAGES } from './orthopedics';
import { DERMATOLOGY_PAGES } from './dermatology';
import { GENERAL_PAGES } from './general';

export const SYMPTOM_PAGES = [
  ...UROLOGY_PAGES,
  ...ORTHOPEDICS_PAGES,
  ...DERMATOLOGY_PAGES,
  ...GENERAL_PAGES,
];

export const SYMPTOM_BY_SLUG = SYMPTOM_PAGES.reduce((acc, p) => {
  acc[p.slug] = p;
  return acc;
}, {});

// Ordered list of specialties used by the symptoms hub UI.
export const SPECIALTIES = [
  'Urology',
  'Orthopedics',
  'Dermatology',
  'General Medicine',
  'Pediatrics',
  'Nephrology',
  'Pulmonology',
  'Psychiatry',
  'Gastroenterology',
];
